import { useState } from 'react';

const testimonials = [
  {
    name: 'Robert Hargrove',
    title: 'CEO, Hargrove Industrial Supply',
    location: 'Houston, TX',
    revenue: '$42M Revenue',
    quote:
      'TCSA came in when we were bleeding cash and had no clear path forward. Within 90 days they had restructured our operations, cut waste by 22%, and put us on a trajectory we hadn\'t seen in years. They don\'t just advise — they roll up their sleeves and get it done.',
    rating: 5,
    initials: 'RH',
  },
  {
    name: 'Sandra Whitfield',
    title: 'Founder & President, Whitfield Healthcare Group',
    location: 'Dallas, TX',
    revenue: '$18M Revenue',
    quote:
      'We were preparing for a PE exit and had no idea where to start. The TCSA team walked us through every step — from cleaning up our financials to positioning our story for buyers. We closed at a multiple we never thought possible. Absolutely worth every dollar.',
    rating: 5,
    initials: 'SW',
  },
  {
    name: 'Marcus Deleon',
    title: 'COO, Deleon Distribution Co.',
    location: 'San Antonio, TX',
    revenue: '$67M Revenue',
    quote:
      'Our supply chain was a mess and our margins were shrinking quarter over quarter. TCSA identified the root causes fast and built a roadmap that actually worked. Six months later we\'re running leaner than ever and our team has never been more aligned.',
    rating: 5,
    initials: 'MD',
  },
  {
    name: 'Patricia Nguyen',
    title: 'Managing Director, Apex Professional Services',
    location: 'Austin, TX',
    revenue: '$11M Revenue',
    quote:
      'What sets TCSA apart is that they\'ve actually been in the C-suite. They understand the pressure, the politics, and the real decisions that have to be made. Their guidance helped us double our utilization rate and finally build a scalable delivery model.',
    rating: 5,
    initials: 'PN',
  },
  {
    name: 'James Calloway',
    title: 'Owner, Calloway Manufacturing',
    location: 'Fort Worth, TX',
    revenue: '$29M Revenue',
    quote:
      'I was skeptical of consultants — I\'d been burned before. But TCSA was different from day one. They were direct, honest about what would and wouldn\'t work, and delivered results that showed up on our P&L. I\'d recommend them to any Texas business owner without hesitation.',
    rating: 5,
    initials: 'JC',
  },
  {
    name: 'Diane Okafor',
    title: 'CEO, Okafor Tech Solutions',
    location: 'Austin, TX',
    revenue: '$8M Revenue',
    quote:
      'TCSA helped us get investor-ready in a way we couldn\'t have done alone. They sharpened our pitch, cleaned up our unit economics, and introduced us to the right conversations. We closed our Series A six months ahead of schedule.',
    rating: 5,
    initials: 'DO',
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);

  const prev = () => setActive((a) => (a === 0 ? testimonials.length - 1 : a - 1));
  const next = () => setActive((a) => (a === testimonials.length - 1 ? 0 : a + 1));

  const t = testimonials[active];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-14">
          <span className="text-texas-red text-xs font-bold tracking-widest uppercase mb-3 block">Client Stories</span>
          <h2 className="text-3xl md:text-4xl font-bold text-texas-navy mb-3">What Our Clients Say</h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Real results from real Texas business leaders who trusted TCSA to transform their companies.
          </p>
        </div>

        {/* Featured testimonial */}
        <div className="bg-texas-navy rounded-lg p-8 md:p-12 mb-8 relative overflow-hidden">
          {/* Decorative quote mark */}
          <div className="absolute top-6 right-8 text-white/5 text-[120px] font-serif leading-none select-none">&ldquo;</div>

          <div className="relative z-10 flex flex-col md:flex-row gap-8 items-start">
            {/* Avatar */}
            <div className="flex-shrink-0">
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-texas-red text-white text-xl font-bold">
                {t.initials}
              </div>
            </div>

            {/* Content */}
            <div className="flex-1">
              {/* Stars */}
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-texas-red text-sm" />
                  </div>
                ))}
              </div>

              <blockquote className="text-white/85 text-base md:text-lg leading-relaxed mb-6 italic">
                &ldquo;{t.quote}&rdquo;
              </blockquote>

              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                <div>
                  <p className="text-white font-bold text-sm">{t.name}</p>
                  <p className="text-white/55 text-xs">{t.title}</p>
                </div>
                <div className="hidden sm:block w-px h-8 bg-white/20" />
                <div className="flex items-center gap-3">
                  <span className="text-xs text-white/40 flex items-center gap-1">
                    <i className="ri-map-pin-line" /> {t.location}
                  </span>
                  <span className="text-xs text-texas-red font-semibold bg-texas-red/15 px-2 py-0.5 rounded-full">
                    {t.revenue}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Nav arrows */}
          <div className="flex items-center gap-3 mt-8 md:mt-6 justify-end">
            <button
              onClick={prev}
              className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:border-texas-red hover:text-texas-red transition-colors cursor-pointer"
              aria-label="Previous"
            >
              <i className="ri-arrow-left-s-line text-lg" />
            </button>
            <span className="text-white/30 text-xs">{active + 1} / {testimonials.length}</span>
            <button
              onClick={next}
              className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:border-texas-red hover:text-texas-red transition-colors cursor-pointer"
              aria-label="Next"
            >
              <i className="ri-arrow-right-s-line text-lg" />
            </button>
          </div>
        </div>

        {/* Thumbnail dots / mini cards */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          {testimonials.map((item, idx) => (
            <button
              key={idx}
              onClick={() => setActive(idx)}
              className={`rounded-lg p-3 text-left transition-all duration-200 cursor-pointer border ${
                active === idx
                  ? 'bg-texas-red-light border-texas-red'
                  : 'bg-gray-50 border-gray-200 hover:border-texas-red/30'
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-full text-xs font-bold mb-2 ${
                active === idx ? 'bg-texas-red text-white' : 'bg-texas-navy text-white'
              }`}>
                {item.initials}
              </div>
              <p className={`text-xs font-semibold leading-snug ${active === idx ? 'text-texas-red' : 'text-texas-navy'}`}>
                {item.name}
              </p>
              <p className="text-[10px] text-gray-400 mt-0.5 leading-snug">{item.location}</p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
